/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum V1DocumentDataStatusStringEnum {
  'DocumentDataStatusIdleString' = 'idle',
  'DocumentDataStatusApprovedString' = 'approved',
  'DocumentDataStatusDeclinedString' = 'declined',
  'DocumentDataStatusUnknownString' = 'unknown',
}

export type V1DocumentDataStatusString = V1DocumentDataStatusStringEnum